import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 6.19922,
			width: 11.5,
			height: 1.6,
			rx: .8,
			fill: "#363F5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5 5.8002C16.8372 5.8002 16.3 6.33745 16.3 7.0002C16.3 7.66294 16.8372 8.2002 17.5 8.2002C18.1627 8.2002 18.7 7.66294 18.7 7.0002C18.7 6.33745 18.1627 5.8002 17.5 5.8002ZM14.7 7.0002C14.7 5.4538 15.9536 4.2002 17.5 4.2002C19.0463 4.2002 20.3 5.4538 20.3 7.0002C20.3 8.54659 19.0463 9.8002 17.5 9.8002C15.9536 9.8002 14.7 8.54659 14.7 7.0002Z",
			fill: "#363F5A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 11.5,
			height: 1.6,
			rx: .8,
			transform: "matrix(-1 0 0 1 20 15.1992)",
			fill: "#363F5A"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(-1 0 0 1 8.5 14)",
			stroke: "#363F5A",
			strokeWidth: 1.6
		})
	]
});
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
